var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemoryWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07617 16H17.9238C19.6199 16 21 14.6196 21 12.9231V3.07692C21 1.38039 19.6199 0 17.9238 0H3.07617C1.38005 0 0 1.38039 0 3.07692V12.9231C0 14.6196 1.38005 16 3.07617 16ZM8.03906 4.92308C8.03906 4.69953 8.16043 4.49337 8.35628 4.38462C8.54975 4.27643 8.79067 4.28185 8.98053 4.40144L13.9024 7.47836C14.0821 7.59073 14.1914 7.78786 14.1914 8C14.1914 8.21214 14.0821 8.40927 13.9024 8.52164L8.98053 11.5986C8.88078 11.661 8.76787 11.6923 8.6543 11.6923C8.55155 11.6923 8.44881 11.6665 8.35628 11.6154C8.16043 11.5066 8.03906 11.3005 8.03906 11.0769V4.92308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryWhite);
export default __webpack_public_path__ + "static/media/memory-white.cff797cdd62119107673761d8c581038.svg";
export { ForwardRef as ReactComponent };